import './avatar.scss';
import PropTypes from "prop-types";

function Avatars ({participants, colorsPalette}) {
    return (
        <>
            {participants?.length > 0 && (
                <div className="avatars">
                    {participants.slice(0, 3).map((participant, index) => {
                        const backgroundColor = colorsPalette[index % colorsPalette.length];
                        const detail = participant.details.find(
                            (item) => item.name === "Name"
                        );

                        return (
                            <div
                                key={index}
                                className="avatar"
                                style={{
                                    backgroundColor: backgroundColor,
                                    color: 'white'
                                }}
                            >
                                {detail ? detail.value[0] : "N/A"}
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};



Avatars.propTypes = {
    participants: PropTypes.arrayOf(
        PropTypes.shape({
            details: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    value: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.arrayOf(PropTypes.string)
                    ]).isRequired
                })
            ).isRequired
        })
    ).isRequired,
    colorsPalette: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default Avatars;